import { render } from "./ShippingReturnPolicy.vue?vue&type=template&id=95a43e92"
import script from "./ShippingReturnPolicy.vue?vue&type=script&lang=js"
export * from "./ShippingReturnPolicy.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ShippingReturnPolicy.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Users\\antho\\Documents\\Projects\\ynforma-website\\ynforma-website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__